module.exports = __webpack_public_path__ + "static/media/pdf_preview.1b6c30e9.svg";